import { useEffect, useState } from "react"
import useSiniestrosStore from "../store/siniestrosStore";
import { isEmpty } from "../utils/functions";

export const useFetchSinisterData = (id = '') => {
    const [sinister, setSinister] = useState({});
    const { loading, getSinisterStatus, submitTicket } = useSiniestrosStore();

    useEffect(() => {
        if (!isEmpty(id)) {
            (async () => {
                const response = await getSinisterStatus(id);

                if (!isEmpty(response.sinister_number)) {
                    setSinister(response);
                }
            })();
        }
    }, [id]);

    const submit = async (uuid, uuidTopic, question) => {
        const response = await submitTicket(uuid, uuidTopic, {
            question: question
        });
        
        return response;
    }

    return { loading, sinister, submit };
}